import actions from './actions';

const initState = {
    productGroup   : {},
    loading : false,
    errorMessage: null
};

export default function createOrUpdateProductGroupReducer(state = initState, action) {
    switch (action.type) {
        case actions.CREATE_OR_UPDATE_PRODUCT_GROUP_REQUESTED:
            return {
                ...state,
                productGroup   : {},
                loading : true
            };
        case actions.CREATE_OR_UPDATE_PRODUCT_GROUP_SUCCEEDED:

            return {
                ...state,
                productGroup   : action.productGroup,
                loading    : false
            };
        case actions.CREATE_OR_UPDATE_PRODUCT_GROUP_FAILED:
            return {
                ...state,
                loading : false,
                errorMessage: action.error
            };
        default:
            return state;
    }
}
